"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var validation_1 = require("utils/helpers/validation");
var firstColumn = 3;
var secondColumn = 12 - firstColumn;
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('isOpen', 'setIsOpen', true), recompose_1.pure);
var Input = (0, recompose_1.compose)((0, recompose_1.withState)('value', 'setValue', null), recompose_1.pure)(function (props) {
    var billing = props.selected;
    var value = '';
    if (props.value === null) {
        value =
            billing && billing.type === 'CUSTOM'
                ? billing[props.fieldName]
                : '';
    }
    else {
        value = props.value;
    }
    return (React.createElement(sok_ui_1.TextInput, { key: "input-".concat(String(props.fieldName)), name: "custom-".concat(String(props.fieldName)), className: 'white', value: value, onChange: function (e) { return props.setValue(e.target.value); }, onBlur: function () {
            var oldValue = billing && billing.type === 'CUSTOM'
                ? billing[props.fieldName]
                : '';
            if (value === oldValue) {
                return;
            }
            if ((billing === null || billing === void 0 ? void 0 : billing.type) === 'CUSTOM') {
                billing[props.fieldName] = value;
                props.setBillingInformation(billing);
            }
            props.setValue(null);
        }, disabled: props.disable }));
});
var Component = enhance(function (props) { return (React.createElement(sok_ui_1.Accordion, { isOpen: props.isOpen },
    React.createElement(sok_ui_1.AccordionHeader, { onClick: function () { return props.setIsOpen(!props.isOpen); }, isOpen: props.isOpen }, (0, translation_1.getLocalization)('userfront/customBillingInformation/selectedBillingInformationTitle')),
    React.createElement("div", { className: 'billing-information' },
        React.createElement("div", { className: 'billing-details' },
            React.createElement(sok_ui_1.Row, null,
                React.createElement(sok_ui_1.Column, { small: firstColumn },
                    React.createElement("label", { htmlFor: 'custom-company' }, (0, translation_1.getLocalization)('userfront/customBillingInformation/company'))),
                React.createElement(sok_ui_1.Column, { small: secondColumn },
                    React.createElement(Input, __assign({}, props, { fieldName: 'customerName' })),
                    props.errors && (0, validation_1.getError)('customerName', props.errors) && (React.createElement("p", { className: 'form-error' }, (0, validation_1.getError)('customerName', props.errors))))),
            React.createElement(sok_ui_1.Row, null,
                React.createElement(sok_ui_1.Column, { small: firstColumn },
                    React.createElement("label", { htmlFor: 'custom-address' }, (0, translation_1.getLocalization)('userfront/customBillingInformation/streetAddress'))),
                React.createElement(sok_ui_1.Column, { small: secondColumn },
                    React.createElement(Input, __assign({}, props, { fieldName: 'streetAddress' })),
                    props.errors && (0, validation_1.getError)('streetAddress', props.errors) && (React.createElement("p", { className: 'form-error' }, (0, validation_1.getError)('streetAddress', props.errors))))),
            React.createElement(sok_ui_1.Row, null,
                React.createElement(sok_ui_1.Column, { small: firstColumn },
                    React.createElement("label", { htmlFor: 'custom-postal-code' }, (0, translation_1.getLocalization)('userfront/customBillingInformation/postalCode'))),
                React.createElement(sok_ui_1.Column, { small: secondColumn },
                    React.createElement(Input, __assign({}, props, { fieldName: 'postalCode' })),
                    props.errors && (0, validation_1.getError)('postalCode', props.errors) && (React.createElement("p", { className: 'form-error' }, (0, validation_1.getError)('postalCode', props.errors))))),
            React.createElement(sok_ui_1.Row, null,
                React.createElement(sok_ui_1.Column, { small: firstColumn },
                    React.createElement("label", { htmlFor: 'custom-city' }, (0, translation_1.getLocalization)('userfront/customBillingInformation/city'))),
                React.createElement(sok_ui_1.Column, { small: secondColumn },
                    React.createElement(Input, __assign({}, props, { fieldName: 'city' })),
                    props.errors && (0, validation_1.getError)('city', props.errors) && (React.createElement("p", { className: 'form-error' }, (0, validation_1.getError)('city', props.errors))))),
            React.createElement(sok_ui_1.Row, null,
                React.createElement(sok_ui_1.Column, { small: firstColumn },
                    React.createElement("label", { htmlFor: 'custom-invoice-reference' }, (0, translation_1.getLocalization)('userfront/customBillingInformation//invoiceReference'))),
                React.createElement(sok_ui_1.Column, { small: secondColumn },
                    React.createElement(Input, __assign({}, props, { fieldName: 'referenceNumber' })),
                    props.errors && (0, validation_1.getError)('referenceNumber', props.errors) && (React.createElement("p", { className: 'form-error' }, (0, validation_1.getError)('referenceNumber', props.errors))))))))); });
exports.default = Component;
